import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/people/about-us-1.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/people/about-us-2.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/people/andrea.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/people/danilo.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/people/roberta.jpg");
;
import(/* webpackMode: "eager" */ "/app/public/people/romina.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/blur-fade.tsx");
